import * as z from "zod";

export const EnquiryStatusEnum = z.enum([
  "new",
  "in_progress",
  "completed",
  "archived",
]);

export const WebsiteEnquirySchema = z.object({
  id: z.string().uuid(),
  name: z
    .string()
    .min(1, "Name is required")
    .max(100, "Name must be less than 100 characters"),
  email: z
    .string()
    .email("Invalid email address")
    .max(255, "Email must be less than 255 characters"),
  phone: z
    .string()
    .max(20, "Phone number must be less than 20 characters")
    .optional(),
  company: z
    .string()
    .max(100, "Company name must be less than 100 characters")
    .optional(),
  message: z
    .string()
    .min(1, "Message is required")
    .max(2000, "Message must be less than 2000 characters"),
  status: z
    .string()
    .max(20, "Status must be less than 20 characters")
    .default("new"),
  created: z
    .date()
    .optional()
    .default(() => new Date()),
  updated: z
    .date()
    .optional()
    .default(() => new Date()),
});

export const createEnquirySchema = WebsiteEnquirySchema.omit({
  id: true,
  status: true,
  created: true,
  updated: true,
});

export const updateEnquirySchema = WebsiteEnquirySchema.partial().omit({
  id: true,
  created: true,
  updated: true,
});
